export enum LeasingVehicleTypeEnum {
  Car = 'passenger_car',
  Other = 'other',
  TruckUnder35 = 'light_commercial_vehicle',
}
